import cn from "classnames";
import { LoaderProps } from "./Loader.types";
import s from "./Loader.module.scss";

const BARS = Array.from({ length: 8 });

export const Loader = ({ text, className }: LoaderProps) => (
  <div className={cn(s.loader, className)}>
    <div className={s.spinner}>
      {BARS.map((_, i) => (
        <span key={i} className={s.bar} />
      ))}
    </div>
    {text && <span className={s.text}>{text}</span>}
  </div>
);
